import { Preferences } from "@capacitor/preferences";
import { logError } from "@src/appV2/lib/analytics";
import {
  useMutation,
  type UseMutationOptions,
  type UseMutationResult,
} from "@tanstack/react-query";

interface PreferenceRequest {
  key: string;
  value: string;
}

export function useSetPreference(
  options: UseMutationOptions<void, Error, PreferenceRequest> = {}
): UseMutationResult<void, Error, PreferenceRequest> {
  return useMutation(["preferences"], {
    mutationFn: async (data: PreferenceRequest) => {
      try {
        await Preferences.set({
          key: data.key,
          value: data.value,
        });
      } catch (error) {
        logError("Error setting preference:", {
          error,
          metadata: {
            key: data.key,
            value: data.value,
          },
        });
        throw error;
      }
    },
    ...options,
  });
}
